export default __webpack_public_path__ + "static/media/wallet-shopee.634a43d3.svg";